import React from 'react';
import { Helmet } from 'react-helmet';
import loadable from '@loadable/component';
// import Loadable from 'react-loadable';

const Loading = loadable(() => import('./../Loading/Loading'));
// const LoadableComponent = Loadable({
//   loader: () => import('./my-component'),
//   loading: Loading,
// });

const Heading = loadable(() => import('../Header/Header'), {
  fallback: <Loading />,
});
const Footer = loadable(() => import('../Footer/Footer'), {
  fallback: <Loading />,
});

// import Loading from './../Loading/Loading';

const Layout = ({ children }) => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Amit Chakraborty</title>
        <meta
          name="description"
          content="freelancer software engineer coder open source developer"
        />
        <link
          rel="icon"
          href="https://cdn1.iconfinder.com/data/icons/UltraBuuf/512/A.png"
          type="image/png"
          sizes="16x16"
        />
      </Helmet>
      <Heading />
      <main>{children}</main>
      {/* <Loading /> */}
      <Footer />
    </>
  );
};

export default Layout;
